<div id="home-header-page" class="home-header-page" [ngStyle]="{'margin-bottom': windowWidth >= 1200 ? '30px':'10px;'}">
    <header class="gray-header" *ngIf="isInternal && windowWidth>1024">
        <div *ngIf="isInternal && !hideMenu" class="user-info">
            <!-- elastic search feature on hold for Aug-2021 production release -->
            <!--  <a href="#" class="search-wrapper" (click)="onElasticSearch();" href="javascript:void(0);"> Search
                    <span class="search-icon fa fa-search"></span>
                </a>
                <span class="header-separator"></span> -->
            <span class="ml-3 user-name">Hello,
                <span class="user-name-text">{{this.authService.instance.getActiveAccount().username}}</span>
            </span>
            <span class="ml-3 header-separator"></span>
            <span class="ml-3 logout" (click)="onLogout()">Sign Out</span>
        </div>
    </header>
    <header class="primary-header">
        <div class="logo float-left">
            <span>
                <a class="" (click)="onLogoClick()" href="{{logoPath}}">
                    <img alt="Lexus" *ngIf="appName==='lexus' && isInternal" class="header-logo" border=0 [src]="commonService.commonFiles['internal-logo']">
                    <img alt="Lexus" *ngIf="appName==='lexus' && !isInternal" class="header-logo header-logocts" [src]="commonService.commonFiles['external-logo']"
                        border=0>
                    <img alt="Toyota" *ngIf="appName==='toyota' && isInternal" class="header-logo" border=0 [src]="commonService.commonFiles['internal-logo']">
                    <img alt="Toyota" *ngIf="appName==='toyota' && !isInternal" class="header-logo header-logocts" border=0 [src]="commonService.commonFiles['external-logo']">
                </a>
            </span>
        </div>
        <app-mode-year-vin-selection *ngIf="windowWidth>1024 && !hideSelectionSection"></app-mode-year-vin-selection>

        <span [ngStyle]="{'visibility': isInternal && !hideMenu && !isMenuOpen && (hasVideo || hasResource || hasMessageGuide) ? 'visible':'hidden'}"
            class="menu-toggle">
            <a (click)="toggleResourceMenu();">
                <span class="fa fa-bars" aria-hidden="true"></span>
            </a>
        </span>

        <div *ngIf="isMenuOpen && windowWidth>1024" class="overlay">
            <div class="resource-popup" id="entire">
                <a>
                    <span (click)="isMenuOpen=!isMenuOpen;" class="fa fa-times close-btn" aria-hidden="true"></span>
                </a>
                <div class="content">
                    <ul>
                        <li [ngClass]="{'active':isResourcePanelOpened}" *ngIf="hasResource && showResources && isInternal">
                            <a href="javascript:void(0);" style="cursor:default">
                                {{ "Label.resources" | translate}}
                            </a>
                            <div class="resource-block">
                                <div class="resource-inner-block" [ngClass]="{'toyota':appName==='toyota','lexus':appName==='lexus'}">
                                    <div class="row">
                                        <div *ngFor="let key of Group;let i =index;">
                                            <div class="section-wrapper" [ngClass]="{'last':(i + 1) % 3 == 0 || Group.length - 1 == i}">
                                                <h3 class="section-title"> {{key}} </h3>
                                                <div class="section-content">
                                                    <ul *ngIf="content && content.length">
                                                        <li *ngFor="let doc of content" [hidden]="key !== doc.resources.resourceGroup">
                                                            <a *ngIf="key == doc.resources.resourceGroup" (click)="openFileInNewTab($event,doc.resources.resourceUrl)" rel="noopener" target="_blank"
                                                                href="{{doc.resources.resourceUrl}}" class="section-content-text resource-name-text">{{doc.resources.resourceName}}</a>
                                                            <span class="new-resource" *ngIf="doc.resources.isNewResource && key == doc.resources.resourceGroup && calculateDateDiff(doc.uploadedTime)">
                                                                New</span>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </li>
                        <li *ngIf="hasVideo && isInternal" style="margin-top:20px; ">
                            <div>
                                <a href="javascript:void(0);" style="cursor:default">
                                    {{ "Label.videos" | translate}}
                                </a>
                                <div class="resource-block" id="videos-containers">
                                    <div class="resource-inner-block" [ngClass]="{'toyota':appName==='toyota','lexus':appName==='lexus'}">
                                        <div class="row">
                                            <div *ngFor="let key of videoGroup;let i =index;">
                                                <div class="section-wrapper" [ngClass]="{'last':(i + 1) % 3 == 0 || videoGroup.length - 1 == i}">
                                                    <h3 class="section-title"> {{key}} </h3>
                                                    <div class="section-content">
                                                        <ul *ngIf="videoContent && videoContent.length">
                                                            <li *ngFor="let doc of videoContent" [hidden]="key !== doc.videos.videoGroup">
                                                                <a *ngIf="key == doc.videos.videoGroup && doc.videos.videoName && doc.videos.videoName !== ''" (click)="openDialog(doc.videos.videoUrl);"
                                                                    target="_blank" class="section-content-text resource-name-text">{{doc.videos.videoName}}</a>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </li>
                        <!-- Message guide hided for the Userstory TCCP-1632 -->
                        <li [hidden]="true" *ngIf="isInternal && hasMessageGuide" [ngClass]="{'active':showErrorGuide}" (click)="onErrorGuideClick($event);">
                            <a href="javascript:void(0);">
                                {{ "Button.error_guides" | translate}}
                                <span class="fa fa-angle-down" [ngClass]="{'active':showErrorGuide && isMenuOpen}">
                                </span>
                            </a>
                        </li>
                        <li class="video" *ngIf="false" (click)="onVideosClick($event)">
                            <!-- removed for 1485 ::  *ngIf="hasVideo && !isInternal"-->
                            <a href="{{routerPath}}">{{ "Label.support_videos" | translate}}
                                <span class="fa fa-angle-down" [ngClass]="{'active':isVideoPanelOpened}"></span>
                            </a>
                            <app-resources-container (showResourceCount)='displayCounter($event)' [type]="'videos'" [data]="videos" [isOpened]="isVideoPanelOpened">
                            </app-resources-container>
                        </li>
                        <li class="btn-status d-flex justify-center" *ngIf="isInternal" style="margin-bottom: 30px;">
                            <span class="ctp-portal-container">
                                <a class="ctp-portal-btn text-decoration-none" rel="noopener noreferrer" href="{{ctpAdminPortalUrl}}" target="_blank" (click)="onServiceStatusClick($event);">{{ "Button.ctp_admin_portal" | translate}}</a>
                            </span>
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        <div *ngIf="isMenuOpen && windowWidth<1024" class="overlay">
            <div class="responsive-header-menu">

                <button (click)="toggleResourceMenu();" mat-icon-button class="close-button">
                    <mat-icon class="close-icon">close</mat-icon>
                </button>
                <div class="content">
                    <ul>
                        <li>
                            <span class="user-name">Hello,
                                <span class="user-name-text">{{this.authService.instance.getActiveAccount().username}}</span>
                            </span>
                        </li>

                        <li [ngClass]="{'active':isResourcePanelOpened}" *ngIf="hasResource && showResources && isInternal">
                            <a href="javascript:void(0);" style="cursor:default">
                                <span class="menu-icons" aria-hidden="true">
                                    <mat-icon *ngIf="hideResources" (click)="toggleExpandedDisplay('resourceDetails');">add_circle_outline</mat-icon>
                                    <mat-icon *ngIf="!hideResources" (click)="toggleExpandedDisplay('resourceDetails');">remove_circle_outline</mat-icon>

                                </span> {{ "Label.resources" | translate}}
                            </a>

                            <div class="resource-block resorce-responsive-block">
                                <div class="resource-inner-block" [hidden]="hideResources" [ngClass]="{'toyota':appName==='toyota','lexus':appName==='lexus'}">
                                    <div class="row">
                                        <div *ngFor="let key of Group;let i =index;">
                                            <div class="section-wrapper responsive-section-block" [ngClass]="{'last':(i + 1) % 3 == 0 || Group.length - 1 == i}">
                                                <h3 class="section-title"> {{key}} </h3>
                                                <div class="section-content">
                                                    <ul *ngIf="content && content.length">
                                                        <li *ngFor="let doc of content" [hidden]="key !== doc.resources.resourceGroup">
                                                            <a *ngIf="key == doc.resources.resourceGroup" (click)="openFileInNewTab($event,doc.resources.resourceUrl)" rel="noopener" target="_blank"
                                                                href="{{doc.resources.resourceUrl}}" class="section-content-text resource-name-text">{{doc.resources.resourceName}}</a>
                                                            <span class="new-resource" *ngIf="doc.resources.isNewResource && key == doc.resources.resourceGroup && calculateDateDiff(doc.uploadedTime)">
                                                                New</span>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </li>

                        <li *ngIf="hasVideo && isInternal">
                            <a href="javascript:void(0);" style="cursor:default">
                                <span class="menu-icons" aria-hidden="false">
                                    <mat-icon *ngIf="hideVideos" (click)="toggleExpandedDisplay('videoDetails');">add_circle_outline</mat-icon>
                                    <mat-icon *ngIf="!hideVideos" (click)="toggleExpandedDisplay('videoDetails');">remove_circle_outline</mat-icon>
                                </span> {{ "Label.videos" | translate}}
                            </a>
                            <div class="resource-block resorce-responsive-block">
                                <div class="resource-inner-block" [hidden]="hideVideos" [ngClass]="{'toyota':appName==='toyota','lexus':appName==='lexus'}">
                                    <div class="row">
                                        <div *ngFor="let key of videoGroup;let i =index;">
                                            <div class="section-wrapper responsive-section-block" [ngClass]="{'last':(i + 1) % 3 == 0 || videoGroup.length - 1 == i}">
                                                <h3 class="section-title"> {{key}} </h3>
                                                <div class="section-content">
                                                    <ul *ngIf="videoContent && videoContent.length">
                                                        <li *ngFor="let doc of videoContent" [hidden]="key !== doc.videos.videoGroup">
                                                            <a *ngIf="key == doc.videos.videoGroup" (click)="openDialog(doc.videos.videoUrl);" target="_blank" class="section-content-text resource-name-text">{{doc.videos.videoName}}</a>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </li>
                        <!-- Message guide hided for the Userstory TCCP-1632 -->
                        <li [hidden]="true" *ngIf="isInternal && hasMessageGuide" [ngClass]="{'active':showErrorGuide}" (click)="onErrorGuideClick($event);">
                            <a href="javascript:void(0);">
                                {{ "Button.error_guides" | translate}}
                                <span class="fa fa-angle-down" [ngClass]="{'active':showErrorGuide && isMenuOpen}">
                                </span>
                            </a>
                        </li>
                        <li class="video" *ngIf="false" (click)="onVideosClick($event)">
                            <a href="{{routerPath}}">{{ "Label.support_videos" | translate}}
                                <span class="fa fa-angle-down" [ngClass]="{'active':isVideoPanelOpened}"></span>
                            </a>
                            <app-resources-videos (showResourceCount)='displayCounter($event)' [type]="'videos'" [data]="videos" [isOpened]="isVideoPanelOpened">
                            </app-resources-videos>
                        </li>
                        <li>
                            <a>
                                <i class="fa fa-sign-out menu-icons" aria-hidden="true"></i>
                                <span class="logout" (click)="onLogout()">Sign Out</span>
                            </a>
                        </li>
                    </ul>
                    <div class="ctp-portal-block-responsive">
                        <ul>
                            <li class="btn-status d-flex justify-center" *ngIf="isInternal">
                                <span class="ctp-portal-container">
                                    <a class="ctp-portal-btn text-decoration-none" rel="noopener noreferrer" href="{{ctpAdminPortalUrl}}" target="_blank" (click)="onServiceStatusClick($event);">{{ "Button.ctp_admin_portal" | translate}}</a>
                                </span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </header>
</div>